// Backend Lookup.Category values — must match exactly. Used by LookupSelector.
export const LOOKUP_CATEGORY = Object.freeze({
  EQUIPMENT_CATEGORY: 'EquipmentCategory',
  DOSAGE_FORM: 'DosageForm',
  ADMINISTRATION_ROUTE: 'AdministrationRoute',
  DETECTION_TECHNIQUE: 'DetectionTechnique',
  SAMPLING_METHOD: 'SamplingMethod',
  CLEANING_AGENT_TYPE: 'CleaningAgentType',
  MITIGATION_STRATEGY: 'MitigationStrategy',
  CONTROL_TYPE: 'ControlType',
  DOCUMENT_TYPE: 'DocumentType',
});
